/**
 * Sammelt Client Hints (Chromium) + Fallback-UA für die Admin-Nutzungsstatistik.
 * Safari/iOS liefert meist keine High-Entropy-Hints → nur User-Agent.
 * Native App: Modell/Hersteller aus Capacitor Device (über clientIdentity).
 */
import { getClientIdentity } from './clientIdentity';

export async function collectClientDeviceInfo() {
    const identity = getClientIdentity();
    const info = {
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        language: typeof navigator !== 'undefined' ? (navigator.language || '') : '',
        touchPoints: typeof navigator !== 'undefined' ? (navigator.maxTouchPoints || 0) : 0,
        screen: typeof screen !== 'undefined'
            ? { w: screen.width, h: screen.height }
            : null,
    };
    if (identity.model) {
        info.model = identity.model;
    }
    if (identity.manufacturer) {
        info.manufacturer = identity.manufacturer;
    }

    try {
        const uaData = typeof navigator !== 'undefined' ? navigator.userAgentData : null;
        if (!uaData) {
            return info;
        }

        info.mobile = uaData.mobile;
        info.brands = uaData.brands;
        info.platform = uaData.platform;

        if (typeof uaData.getHighEntropyValues === 'function') {
            const high = await uaData.getHighEntropyValues([
                'architecture',
                'bitness',
                'model',
                'platformVersion',
                'fullVersionList',
                'uaFullVersion',
            ]);
            const nativeModel = info.model;
            Object.assign(info, high);
            if (nativeModel) {
                info.model = nativeModel;
            }
        }
    } catch (err) {
        // Client Hints können fehlen oder abgelehnt werden — UA-Fallback reicht.
    }

    return info;
}
